export default {
    title: 'Loading...',
}
